export default {
    title: 'Loading...',
}
